import { render, staticRenderFns } from "./BasicStatWidget.vue?vue&type=template&id=2fdf702a&"
import script from "./BasicStatWidget.vue?vue&type=script&lang=js&"
export * from "./BasicStatWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports